import {useEffect, useState, useRef} from 'react'
import {withRouter} from 'react-router-dom';
import {Breadcrumb, Col, Container, Row} from 'react-bootstrap'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight, faTruck} from "@fortawesome/free-solid-svg-icons";
import Api from "../../../../services/Api";
import HelperGeneral from "../../../../helpers/HelperGeneral";
import UserInfo from "../../../auth/UserInfo";
import {Button, Empty, Input, Modal, Spin} from 'antd'
import {setGlobalSpinner} from "../../../../services/redux/actions/GeneralAction";
import moment from "moment";
import order_1 from "../../../../assets/order_1.json";
import order_100001 from "../../../../assets/order_100001.json";
import order_100000001 from "../../../../assets/order_100000001.json";
import order_100000004 from "../../../../assets/order_100000004.json";
import Lottie from "react-lottie";
import {trans} from "../../../../helpers/HelperGlobal";
import _ from "lodash";
import {value} from "lodash/seq";
import {useWindowWidth} from "../../../helpers/useWindowWidth";

const {TextArea} = Input

const Delivery = (props) => {
    const [orderDetail, setOrderDetail] = useState({});
    const [loading, setLoading] = useState(null);
    const [orders, setOrders] = useState([]);
    const [rejectMessage, setRejectMessage] = useState(null);
    const [modal, setModal] = useState({});
    const [modalOpen, setModalOpen] = useState(false);
    const windowWidth = useWindowWidth();

    useEffect(() => {
        getDeliveries();
    }, [])

    const getDeliveries = () => {
        const user = UserInfo.info();
        setLoading(true);
        Api.getDeliveries(user.id, 1).then((e) => {
            setLoading(false);
            setOrders(e?.data?.result);
        }).catch(e => {
            HelperGeneral.alert(e);
            setLoading(false);
        })
    }

    const orderCommit = (orderId, orderNumber, OrderStatus, Message) => {
        setModal({
            orderId: orderId,
            orderNumber: orderNumber,
            OrderStatus: OrderStatus,
            Message: Message,
        });
        setModalOpen(true);
    }

    const orderIcon = (orderStatus) => {
        if (orderStatus === 100001) {
            return (
                <Lottie options={{
                    loop: false,
                    autoplay: true,
                    animationData: order_100001,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                    },
                }} height={120} width={120}/>
            )
        } else if (orderStatus === 100000001) {
            return (
                <Lottie options={{
                    loop: true,
                    autoplay: true,
                    animationData: order_1,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                    },
                }} height={120} width={120}/>
            )
        } else if (orderStatus === 4) {
            return (
                <Lottie options={{
                    loop: true,
                    autoplay: true,
                    animationData: order_100000001,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                    },
                }} height={windowWidth > 575 ? 120 : 100} width={120}/>
            )
        } else if (orderStatus === 100000004) {
            return (
                <Lottie options={{
                    loop: true,
                    autoplay: true,
                    animationData: order_100000004,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                    },
                }} height={120} width={120}/>
            )
        } else {
            return false;
        }
    }

    return (
        <Container className={'p-0 info'}>
            <Row>
                <Col xs={12}>
                    <Spin spinning={loading}>
                        <div className={(Object.keys(orderDetail).length !== 0 ? 'box' : ' product-history') + ' orders'}>
                            {
                                Object.keys(orderDetail).length !== 0 ? (
                                    <>
                                        <h4 className={'mn-2 mb-sm-4 pl-0'}>
                                            <FontAwesomeIcon
                                                icon={faArrowLeft}
                                                style={{cursor: 'pointer'}}
                                                onClick={() => setOrderDetail({})}
                                            /> Teslimat Detayı
                                        </h4>
                                        <div className={'box shadow-none'}>
                                            <Row className={'row'}>
                                                <Col xs={4} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                    {orderIcon(orderDetail?.orderStatus)}
                                                </Col>
                                            </Row>
                                            <Row className={'mt-2 mt-sm-3'}>
                                                <Col xs={12} md={5} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                    <h5>{orderDetail?.orderStatusName ?? '-'}</h5>
                                                </Col>
                                            </Row>
                                            <Row className={'mt-3'}>
                                                <Col xs={12} md={4} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                    <span>Sipariş Numarası</span>
                                                </Col>
                                            </Row>
                                            <Row className={'mt-1'}>
                                                <Col xs={12} md={4} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                    {orderDetail?.orderNumber}
                                                </Col>
                                            </Row>
                                            <Row className={'mt-3'}>
                                                <Col xs={12} md={4} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                    <span>Sipariş Tarihi</span>
                                                </Col>
                                            </Row>
                                            <Row className={'mt-1'}>
                                                <Col xs={12} md={4} className={'mx-auto d-flex justify-content-center align-items-center'}>
                                                    {moment(orderDetail?.orderDate).format('DD.MM.YYYY HH:mm:ss')}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} className={'mt-4'}>
                                                    <h4>Sipariş Özeti</h4>
                                                    {
                                                        orderDetail?.orderProducts &&
                                                        orderDetail?.orderProducts.map((v2, i2) => (
                                                            <Row className={"p-0 pt-3 p-sm-3 pl-0 "} style={{cursor: "pointer"}}>
                                                                <Col xs={12} md={2} className={"d-flex justify-content-start align-items-center"}>
                                                                    <img
                                                                        onClick={() => window.location.href = "/product/" + v2?.product?.productId}
                                                                        src={v2?.product?.imageUrl}
                                                                        className={'img-thumbnail'}
                                                                        style={{
                                                                            width: '100%',
                                                                            maxHeight: windowWidth > 575 ? 70 : 120,
                                                                            objectFit: 'contain'
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col xs={12} md={10} className={"d-flex justify-content-start align-items-center"}>
                                                                    <Row>
                                                                        <Col xs={12} onClick={() => window.location.href = "/product/" + v2?.product?.productId}>
                                                                            {v2?.product?.productName}
                                                                        </Col>
                                                                        <Col xs={12}>
                                                                            <b>{v2?.quantity} Adet</b>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        ))
                                                    }
                                                </Col>
                                                <Col xs={12} className={'mt-4'}>
                                                    <h4>Teslimat Bilgileri</h4>
                                                    <Row className={"p-0 pt-3"}>
                                                        <hr style={{marginLeft: '12px', width: '85%'}}/>
                                                        <Col xs={12}>
                                                            <Row>
                                                                <Col xs={12} md={3}>
                                                                    Teslim Tarihi :
                                                                </Col>
                                                                <Col xs={12} md={9}>
                                                                    -
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xs={12} md={3}>
                                                                    Adı :
                                                                </Col>
                                                                <Col xs={12} md={9}>
                                                                    {orderDetail?.deliveryInfo?.accountDetail?.accountName ?? '-'}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xs={12} md={3}>
                                                                    Telefon Numarası :
                                                                </Col>
                                                                <Col xs={12} md={9}>
                                                                    {orderDetail?.deliveryInfo?.accountDetail?.phoneNumber ?? '-'}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xs={12} md={3}>
                                                                    Adresi :
                                                                </Col>
                                                                <Col xs={12} md={9}>
                                                                    {orderDetail?.deliveryInfo?.accountDetail?.addressLine ?? '-'}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xs={12} md={3}>
                                                                    Teslim Şekli :
                                                                </Col>
                                                                <Col xs={12} md={9}>
                                                                    -
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                {
                                                    orderDetail?.orderStatus === 100000004 && (
                                                        <>
                                                            <Col xs={12} className={'mt-4'}>
                                                                <Row className={"row"}>
                                                                    <Col xs={12} md={6}>
                                                                        <Button
                                                                            onClick={() => orderCommit(orderDetail?.id, orderDetail?.orderNumber, 1, "Siparişi onaylamak istediğinize emin misiniz?")}
                                                                            className={'btn text-white btn-primary w-100'}
                                                                            style={{
                                                                                border: 'none',
                                                                                borderRadius: 3,
                                                                                height: 46,
                                                                            }}
                                                                        >
                                                                            Onayla
                                                                        </Button>
                                                                    </Col>
                                                                    <Col xs={12} md={6}>
                                                                        <Button
                                                                            onClick={() => orderCommit(orderDetail?.id, orderDetail?.orderNumber, 100000002, "Siparişi reddetmek istediğinize emin misiniz?")}
                                                                            className={'btn text-white btn-danger w-100'}
                                                                            style={{
                                                                                border: 'none',
                                                                                borderRadius: 3,
                                                                                height: 46,
                                                                            }}
                                                                        >
                                                                            Reddet
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </Col>

                                                            {
                                                                modalOpen && (
                                                                    <Modal
                                                                        centered={true}
                                                                        onCancel={() => {
                                                                            setModalOpen(false);
                                                                            setModal({});
                                                                        }}
                                                                        visible={modalOpen}
                                                                        onOk={() => {
                                                                            if (rejectMessage === null && modal?.OrderStatus === 100000002) {
                                                                                HelperGeneral.alert("Mesajınızı giriniz.", "error");
                                                                            } else {
                                                                                const data = {
                                                                                    orderId: modal?.orderId,
                                                                                    orderNumber: modal?.orderNumber,
                                                                                    isPaymentApproved: true,
                                                                                    OrderStatus: modal?.OrderStatus,
                                                                                    cancelDescription: rejectMessage
                                                                                };
                                                                                setLoading(true);
                                                                                Api.orderCommit(data).then(r => {
                                                                                    setLoading(false);
                                                                                    getDeliveries();
                                                                                    setModalOpen(false);
                                                                                    setModal({});
                                                                                    setRejectMessage(null);
                                                                                    setOrderDetail({});
                                                                                }).catch((e) => {
                                                                                    setLoading(false);
                                                                                    HelperGeneral.alert(e);
                                                                                })
                                                                            }
                                                                        }}
                                                                    >
                                                                        {
                                                                            modal?.OrderStatus === 1 && (
                                                                                <p>{modal?.Message}</p>
                                                                            )
                                                                        }
                                                                        {
                                                                            modal?.OrderStatus === 100000002 && (
                                                                                <>
                                                                                    <p>{modal?.Message}</p>
                                                                                    <TextArea
                                                                                        className={"mt-3"}
                                                                                        onChange={(e) => {
                                                                                            setRejectMessage(e?.target?.value)
                                                                                        }}
                                                                                        placeholder={"* Reddetme gerekçesi giriniz"}
                                                                                        rows={4}
                                                                                    />
                                                                                </>
                                                                            )
                                                                        }
                                                                    </Modal>
                                                                )
                                                            }
                                                        </>
                                                    )
                                                }
                                            </Row>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <h4 className={'mb-4 pl-0'}>Teslimatlarım</h4>
                                        {
                                            orders.map((v, i) => (
                                                <Container>
                                                    <Row className={'mb-3 order-item'} onClick={() => setOrderDetail(v)}>
                                                        <Col xs={12} md={3} className={'d-flex justify-content-center justify-content-md--start align-items-center mb-2 mb-sm-4 m-md-0'}>
                                                            {
                                                                v.orderProducts &&
                                                                v.orderProducts.slice(0, 2).map((v2, i2) => (
                                                                    <img
                                                                        src={v2?.product?.imageUrl}
                                                                        className={'img-thumbnail '}
                                                                        style={{
                                                                            width: 70,
                                                                            height: 70,
                                                                            borderRadius: '50%',
                                                                            marginLeft: i2 === 1 ? -20 : 0
                                                                        }}
                                                                    />
                                                                ))
                                                            }
                                                            {
                                                                v.orderProducts &&
                                                                v.orderProducts.length > 2 && (
                                                                    <div className={"d-flex justify-content-center align-items-center shadow"}
                                                                         style={{
                                                                             width: 70,
                                                                             height: 70,
                                                                             borderRadius: '50%',
                                                                             background: '#eaeaea',
                                                                             marginLeft: -20,
                                                                             fontSize: 18
                                                                         }}
                                                                    >
                                                                        {v.orderProducts.length - 2} +
                                                                    </div>
                                                                )
                                                            }
                                                        </Col>
                                                        <Col xs={12} md={2} className={'d-flex justify-content-center align-items-center mb-2 mb-sm-4 m-md-0'}>
                                                            <Row className={'h-100'}>
                                                                <Col xs={12} className={'text-center'}>
                                                                    <span>Sipariş Tarihi</span>
                                                                </Col>
                                                                <Col xs={12} className={'text-center'}>
                                                                    {moment(v.orderDate).format('DD.MM.YYYY HH:mm:ss')}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={12} md={2} className={'d-flex justify-content-center align-items-center mb-2 mb-sm-4 m-md-0'}>
                                                            <Row className={'h-100'}>
                                                                <Col xs={12} className={'text-center'}>
                                                                    <span>Sipariş Numarası</span>
                                                                </Col>
                                                                <Col xs={12} className={'text-center'}>
                                                                    {v.orderNumber}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={12} md={2} className={'d-flex justify-content-center align-items-center mb-2 mb-sm-4 m-md-0'}>
                                                            {v.deliveryType === 1 ? 'Eczaneden Teslim' : 'Adrese Teslim'}
                                                        </Col>
                                                        <Col xs={12} md={2} className={'d-flex justify-content-center align-items-center mb-2 mb-sm-4 m-md-0'}>
                                                            {v.orderStatusName ?? '-'}
                                                        </Col>
                                                        <Col xs={12} md={1} className={'d-flex justify-content-center align-items-center'}>
                                                            <FontAwesomeIcon icon={faArrowRight}/>
                                                        </Col>
                                                    </Row>
                                                </Container>

                                            ))
                                        }

                                        {
                                            !loading && orders.length < 1 && (
                                                <Empty
                                                    description={'Teslimat bulunamadı'}
                                                />
                                            )
                                        }
                                    </>
                                )
                            }
                        </div>
                    </Spin>
                </Col>
            </Row>
        </Container>
    );
}

export default withRouter(Delivery);
